import { 
	createSlice,
	createAsyncThunk
} from '@reduxjs/toolkit'
import {envAwarePost} from '../../../util/util'

const slice = createSlice({
	name: 'billing',
	initialState: {
		updateModal:{
			show:false
		},
		resetCurrencyModal:{
			show:false,
			//if a user has active subscriptions
			//do not show the update form
			allowUpdate:true
		}
	},
	reducers: {
		setShowUpdateModal : (state,action) => { state.updateModal.show = action.payload },
		setShowResetCurrencyModal : (state,action) => { state.resetCurrencyModal.show = action.payload },
		setAllowCurrencyUpdate : (state,action) => { state.resetCurrencyModal.allowUpdate = action.payload },
	},
	extraReducers: {}
})

export const {
	setShowUpdateModal,
	setAllowCurrencyUpdate,
	setShowResetCurrencyModal
} = slice.actions

export const selectShowUpdateModal = state => state.billing.updateModal.show
export const selectShowResetCurrencyModal = state => state.billing.resetCurrencyModal.show
export const selectAllowCurrencyUpdate = state => state.billing.resetCurrencyModal.allowUpdate

export default slice.reducer